import React from 'react';
import PropTypes from 'prop-types';
import { ShortCarouselCard, LazyLoadAspectRatioCardImage, AspectRatioCardTitle, AspectRatioCardText } from '../Carousel/CarouselCard';
import { Experiment } from '../Experiment';
import { getURLWithCookieDetails } from './utils';

const CNAME = 'Trending';

const TrendingCard = ({
  onClick,
  slpUrl,
  imageUrl,
  location,
  name,
  locationQuery,
  loadImage
}) => (
  <Experiment name={'HA_PTA_LANDING_TrendingDestinationsSeRPLink'}>
    {valueTrend =>
      (
        <ShortCarouselCard
          clickUrl={valueTrend ? getURLWithCookieDetails(locationQuery) : (slpUrl || getURLWithCookieDetails(locationQuery))}
          className={`${CNAME}__link`}
          onClick={onClick}
        >
          <LazyLoadAspectRatioCardImage
            data-slot={'figure'}
            imageUri={imageUrl.replace('${templateId}', 'hw6')}
            loadImage={loadImage}
          />
          <AspectRatioCardTitle data-slot={'caption'} title={name} />
          <AspectRatioCardText data-slot={'content'} text={location} />
        </ShortCarouselCard>
      )}
  </Experiment>
);


TrendingCard.propTypes = {
  onClick: PropTypes.func,
  slpUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  location: PropTypes.string,
  name: PropTypes.string,
  cardAspectRatio: PropTypes.string,
  locationQuery: PropTypes.string,
  loadImage: PropTypes.bool.isRequired
};

TrendingCard.defaultProps = {
  cardAspectRatio: '4x3'
};

export default React.memo(TrendingCard);
